import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem } from 'reactstrap';

import './Header.scss';
import Logo from './assets/logo.png';

class Header extends React.Component {
  constructor (props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.getNav = this.getNav.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle () {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  handleLogout () {
    this.props.logoutUser();
  }

  getNav () {
    if (this.props.authenticatedID === null) {
      return (
        <Nav className='ml-auto' navbar>
          <NavItem>
            <Link to='/company/login' className='HeaderNav__link nav-item nav-link'>Login</Link>
          </NavItem>
          <NavItem>
            <Link to='/company/register' className='HeaderNav__link nav-item nav-link'>Signup</Link>
          </NavItem>
        </Nav>
      );
    }

    return (
      <Nav className='ml-auto' navbar>
        <NavItem>
          <a href='/company/logout' className='HeaderNav__link nav-item nav-link'>Logout</a>
        </NavItem>
      </Nav>
    );
  }

  render () {
    return (
      <div className='page-layout__navbar--main'>
        <div className='container HeaderNav'>
          <Navbar inverse toggleable>
            <NavbarBrand href='/company'>
              <img alt='Paragon One' className='header__LogoImage' src={Logo} />
            </NavbarBrand>
            <NavbarToggler right onClick={this.toggle} className='hidden-lg-up' />
            <Collapse isOpen={this.state.isOpen} className='navbar-toggleable-lg' navbar>
              {this.getNav()}
            </Collapse>
          </Navbar>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
};

const mapStateToProps = (state) => ({
  authenticatedID: state.auth.sub || null
});

export default connect(
  mapStateToProps, mapDispatchToProps
)(Header);



// WEBPACK FOOTER //
// ./src/routes/company/layouts/Header/index.js